import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { useNavigate } from "@tanstack/react-router";

import type { UIClient } from "../../types/client.types";
import { formatTokenDate } from "@/lib/dateUtils";

export function ClientListRow({
  client,
  isSelected,
  onSelect,
}: {
  client: UIClient;
  isSelected: boolean;
  onSelect: () => void;
}) {
  const navigate = useNavigate();

  const handleClientClick = () => {
    navigate({
      to: `/admin/client/${client.id}`,
      search: { clientName: client.name },
    });
  };

  return (
    <div
      className="hover:bg-black-950/50 bg-black-950 grid h-[76px] cursor-pointer grid-cols-[auto_0.7fr_1fr_1fr_120px] items-center gap-4 rounded-lg p-5 transition-colors duration-200"
      onClick={handleClientClick}
    >
      <Checkbox
        checked={isSelected}
        onCheckedChange={onSelect}
        className="border-white"
        onClick={(e) => e.stopPropagation()}
      />

      <p className="text-md truncate leading-6 font-bold -tracking-wide text-white">
        {client.name}
      </p>

      <p className="text-md truncate leading-6 font-medium -tracking-wide text-white">
        {client.email}
      </p>

      <div>
        <Badge
          variant="plan"
          className="bg-brand-500 !flex !max-w-[150px] !overflow-hidden py-2.5! text-sm! font-medium"
        >
          <span className="text-admin-bg truncate">{client.plan}</span>
        </Badge>
      </div>

      <p className="text-black-50 text-md leading-3 font-bold -tracking-wide">
        {formatTokenDate(client.subscriptionEndDate)}
      </p>
    </div>
  );
}
